import { render, staticRenderFns } from "./ApplicantKnownLanguagesConf.vue?vue&type=template&id=60a50c31"
import script from "./ApplicantKnownLanguagesConf.vue?vue&type=script&lang=js"
export * from "./ApplicantKnownLanguagesConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports